import { useEffect } from 'react'
import { Paper, Box } from '@mui/material'
import {
  UiFeedbackUsersComponent,
  BrandsFormDialog,
  UsersTableComponent,
  UsersFilters,
  UsersFormDialog,
} from './components'

import { useUsersActions, useUsersFilters, useBrandsActions } from './hooks'

const UsersModule = () => {
  const { getAllUsers, setUserFilters } = useUsersActions()

  const { getAllBrands } = useBrandsActions()

  const { filters } = useUsersFilters()

  useEffect(() => {
    getAllUsers(filters)
    getAllBrands({})
    return () => {
      setUserFilters({
        page: 1,
        limit: 25,
      })
    }
  }, []) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      <Box p={2}>
        <UsersFilters />
      </Box>
      <UsersTableComponent />
      <UiFeedbackUsersComponent />
      <UsersFormDialog />
      <BrandsFormDialog />
    </Box>
  )
}

export default UsersModule
